<template>
  <div v-loading.fullscreen.lock="is_loading">
    <ul class="list-unstyled">
      <li v-for="(doc, index) in docs" :key="index">
        <div class="d-flex">
          <a
            href="#"
            class="mr-1 text-danger"
            @click.prevent="deleteDoc(doc)"
            title="Delete document"
            ><span class="el-icon-close"></span
          ></a>
          <a
            href="#"
            class="mr-3 text-primary"
            @click.prevent="download(doc)"
            title="Download document"
            ><span class="el-icon-download"></span
          ></a>
          <a
            @click.prevent="view(doc)"
            :href="doc.file_dir"
            title="View document"
            v-text="doc.file_dir"
          ></a>
        </div>
      </li>
      <li v-if="docs.length == 0"><i>No documents attached.</i></li>
    </ul>
  </div>
</template>

<script>
import InspectionSheet from "@/models/InspectionSheet";
import api from "@/api";
export default {
  name: "doc-list",

  data() {
    return {
      is_loading: false
    };
  },
  computed: {
    docs() {
      return this.$store.getters["stockin/docs"];
    },
    inspectionSheet() {
      return this.$store.getters["stockin/inspectionSheet"];
    }
  },
  watch: {
    inspectionSheet: {
      handler: function() {
        this.fetch();
      },
      deep: true
    }
  },
  methods: {
    fetch() {
      this.is_loading = true;
      this.$store
        .dispatch("stockin/getDocs", this.inspectionSheet.id)
        .then(() => {
          this.is_loading = false;
        });
    },
    view(doc) {
      // this.$router.push({
      //   name: "pdf_viewer",
      //   query: { id: doc.id }
      // });
      window.open(`/pdf-viewer/doc?type=inventory&id=${doc.id}`, "_blank");
    },
    download(doc) {
      api.download(`/api/v1/inventory/document_list/?id=${doc.id}`, {
        name: "Inspection Sheet Document",
        ext: ".pdf"
      });
    },
    deleteDoc(doc) {
      this.$confirm("Are you sure you want to delete this document?")
        .then(() => {
          this.is_loading = true;
          InspectionSheet.deleteDocument(doc.id).then(() => {
            this.$notify({
              type: "success",
              message: "Document removed successfully.",
              position: "bottom-right"
            });
            this.is_loading = false;
            this.$store.dispatch("stockin/getDocs", this.inspectionSheet.id);
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="css" scoped></style>
